<script setup>
import { useAudioRecorder } from './useAudioRecorder';

const props = defineProps({
  audioRecordFormat: { type: String, required: true },
  height: { type: Number, default: 100 },
});
const emit = defineEmits([
  'recorderProgressChanged',
  'recordingStarted',
  'finishRecord',
  'pause',
  'play',
  'recordError',
]);
const { waveformContainer, playPause, stopRecording, record } =
  useAudioRecorder(
    {
      get audioRecordFormat() {
        return props.audioRecordFormat;
      },
      get height() {
        return props.height;
      },
    },
    emit
  );
defineExpose({ playPause, stopRecording, record });
</script>

<template>
  <div ref="waveformContainer" class="w-full p-1" />
</template>
